import React from "react";

export type TDefaultModelIconProps = React.SVGAttributes<SVGElement>;

export function DefaultModelIcon({ ...rest }: TDefaultModelIconProps) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...rest}>
      <g clipPath="url(#clip0_3838_36)">
        <path d="M23.5601 12.2446C18.941 10.9689 18.0534 10.0813 16.7788 5.46329C16.7068 5.20342 
        16.4706 5.02344 16.2006 5.02344C15.9306 5.02344 15.6943 5.20343 15.6223 5.46329C14.3477 
        10.0812 13.4601 10.9688 8.84097 12.2446C8.58111 12.3166 8.40112 12.5529 8.40112 12.8229C8.40112 
        13.0929 8.58112 13.3291 8.84097 13.4011C13.4601 14.6757 14.3465 15.5633 15.6223 20.1825C15.6943 
        20.4423 15.9306 20.6223 16.2006 20.6223C16.4706 20.6223 16.7068 20.4423 16.7788 20.1825C18.0545 
        15.5634 18.941 14.6769 23.5601 13.4011C23.82 13.3291 24 13.0929 24 12.8229C24 12.5529 23.82 12.3166 23.5601 12.2446Z" fill="#21BE6B" />
        <path d="M2.65128 5.67872C5.46145 6.45494 5.95743 6.95107 6.7327 9.76015C6.8047 10.02 7.04207 10.2 7.31094 
        10.2C7.57981 10.2 7.81829 10.02 7.88917 9.76015C8.66427 6.9511 9.16039 6.45486 11.9706 5.67872C12.2305 5.60672 
        12.4104 5.37048 12.4104 5.10049C12.4104 4.83049 12.2305 4.59425 11.9706 4.52226C9.16042 3.74603 8.66444 3.24991 
        7.88917 0.440828C7.8183 0.180961 7.58093 0.000976562 7.31094 0.000976562C7.04094 0.000976562 6.8047 0.180972 6.7327 
        0.440828C5.95648 3.251 5.46035 3.74612 2.65128 4.52226C2.39141 4.59425 2.21143 4.83049 2.21143 5.10049C2.21143 5.37048 
        2.39142 5.60672 2.65128 5.67872Z" fill="#21BE6B" />
        <path d="M10.3597 18.0227C7.37521 17.1992 6.80153 16.6254 5.97787 13.642C5.90588 13.3821 5.66964 13.2021 5.39964 13.2021C5.12965 
        13.2021 4.89341 13.3821 4.82141 13.642C3.99793 16.6253 3.42419 17.1993 0.439607 18.0227C0.17974 18.0947 -0.000244141 18.3309 -0.000244141 
        18.6009C-0.000244141 18.8709 0.179751 19.1071 0.439607 19.1791C3.42407 20.0037 3.99775 20.5763 4.82141 23.5598C4.89341 23.8196 5.12965 
        23.9996 5.39964 23.9996C5.66964 23.9996 5.90588 23.8196 5.97787 23.5598C6.80136 20.5753 7.3751 20.0025 10.3597 19.1791C10.6195 19.1071 
        10.7995 18.8709 10.7995 18.6009C10.7995 18.3309 10.6184 18.0947 10.3597 18.0227Z" fill="#21BE6B" />
      </g>
      <defs>
        <clipPath id="clip0_3838_36">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
